import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

let kioskSlider = document.getElementById('kioskSlider');

if (kioskSlider) {
    new Swiper('#kioskSlider', {
        modules: [Navigation, Pagination, Autoplay],
        spaceBetween: 0,
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
    });
}